module.exports = __webpack_public_path__ + "static/img/user.5ed64f97.jpg";